import { useState, useContext, Fragment, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { Transition } from '@headlessui/react'
import { useIntercom } from 'react-use-intercom';
import { HomeIcon, ChartBarIcon, XIcon, CashIcon, PencilAltIcon, ChatIcon, CogIcon, TicketIcon, GiftIcon, BookOpenIcon, CakeIcon, ExclamationCircleIcon, NewspaperIcon, RssIcon, SupportIcon, MenuAlt2Icon } from '@heroicons/react/outline'

import Link from '@/components/Link'
import { LayoutContext } from '@/contexts/LayoutContext'
import SidebarTransition from '../transitions/sidebar.transition'
import modalRoutes from '@/modalRoutes'
import Button from '@/components/Button'
import Loader from '@/components/Loader'
import { AuthContext } from '../contexts/AuthContext';
import { classNames } from '@/utils/classNames'

export default function Sidebar() {
  const { sidebar, toggleSidebar, toggleChat } = useContext(LayoutContext)
  const { racesData } = useContext(AuthContext)
  const { showNewMessages } = useIntercom();

  const links = [
    {
      icon: 'ROCKET.svg',
      label: 'Home',
      href: "/"
    },
    {
      icon: 'STAKES.svg',
      label: 'Duel Arena',
      href: "/arena"
    },
    {
      icon: 'CASHIER.svg',
      label: 'Cashier',
      href: modalRoutes.WALLET
    },
    // {
    //   icon: <PencilAltIcon className={classNames('text-gray-200 transition-all duration-300', sidebar ? 'h-4 w-4' : 'w-5 h-5')} />,
    //   label: 'Rakeback',
    //   href: "/rakeback"
    // },
    {
      icon: 'LEADERBOARD.svg',
      label: 'Leaderboards',
      href: "/leaderboard"
    },
    {
      icon: 'CHAT_v2.svg',
      label: 'Chat',
      href: null,
      onClick: () => toggleChat()
    },
    {
      icon: 'SETTINGS.svg',
      label: 'Settings',
      href: "/settings"
    }
  ]
  const helpDesk = [
    // {
    //   icon: <NewspaperIcon className={classNames('text-gray-200 transition-all duration-300', sidebar ? 'h-4 w-4' : 'w-5 h-5')} />,
    //   label: 'News',
    //   href: "/news"
    // },
    // {
    //   icon: <ExclamationCircleIcon className={classNames('text-gray-200 transition-all duration-300', sidebar ? 'h-4 w-4' : 'w-5 h-5')} />,
    //   label: 'Report Abuse',
    //   href: modalRoutes.WALLET
    // },
    {
      icon: 'SUPPORT.svg',
      label: 'Live Support',
      href: null,
      onClick: () => showNewMessages()
    },
  ]

  const location = useLocation()
  const isActive = () => {
    if (typeof to !== "string") return false

    if (location.pathname === '/' && to === '/') return true

    if (to === '/') return false

    if (location.pathname.includes(to)) return true
  }


  return (
    <>
      {/* desktop */}
      <aside className={classNames('flex-col transition-[width] ease-out duration-300 h-screenMinusHeader pt-8 overflow-auto inset-y-0 lg:relative z-50 bg-gray-900 hidden lg:flex', sidebar ? 'w-full w-64' : 'w-[88px]')}>
        <div className={classNames('overflow-auto px-6')}>
          <div className="grid gap-4 border-b border-gray-800 pb-6 overflow-hidden">
            {links.map(({ href, icon, label, onClick }, index) => (
              href ? (
                <Link key={index} className={classNames('group relative text-gray-200 transition-all duration-300 font-medium rounded-md flex items-center space-x-2', sidebar ? 'hover:pl-1.5' : '')} to={href}>
                  <span className={classNames('flex p-1 bg-gray-800 rounded-md', sidebar ? 'mr-1' : '')}>
                    <img className={'transition-all duration-300', classNames(sidebar ? 'w-6' : 'w-8')} src={`/icons/${icon}`} alt="" />
                  </span>
                  <Transition className="flex-1 text-left" as={'div'} show={sidebar}>
                    <Transition.Child
                      as={Fragment}
                      enter="transform delay-400 ease-out duration-300"
                      enterFrom="opacity-0 -translate-x-1 scale-95"
                      enterTo="opacity-100 translate-x-0 scale-100"
                      leave="transform ease-in duration-200"
                      leaveFrom="opacity-100 translate-x-0 scale-100"
                      leaveTo="opacity-0 -translate-x-1 scale-95"
                    >
                      <span className="absolute inset-y-0 whitespace-nowrap flex items-center">{label}</span>
                    </Transition.Child>
                  </Transition>
                </Link>
              ) : (
                <button key={index} className={classNames('group relative text-gray-200 transition-all duration-300 font-medium flex items-center space-x-2', sidebar ? 'hover:pl-1.5' : '')} onClick={onClick}>
                  <span className={classNames('flex p-1 bg-gray-800 rounded-md', sidebar ? 'mr-1' : '')}>
                    <img className={'transition-all duration-300', classNames(sidebar ? 'w-6' : 'w-8')} src={`/icons/${icon}`} alt="" />
                  </span>
                  <Transition className="flex-1 text-left truncate" as={'div'} show={sidebar}>
                    <Transition.Child
                      as={Fragment}
                      enter="transform delay-400 ease-out duration-300"
                      enterFrom="opacity-0 -translate-x-1 scale-95"
                      enterTo="opacity-100 translate-x-0 scale-100"
                      leave="transform ease-in duration-200"
                      leaveFrom="opacity-100 translate-x-0 scale-100"
                      leaveTo="opacity-0 -translate-x-1 scale-95"
                    >
                      <span className="absolute inset-y-0 whitespace-nowrap flex items-center">{label}</span>
                    </Transition.Child>
                  </Transition>
                </button>
              )
            ))}
          </div>
          <div className="grid py-6 gap-1 border-b border-gray-800">
            {racesData.length == 0 ? (
              sidebar ? <p className="py-4 text-gray-200">No promotions available</p> : <Link className={classNames('group relative text-gray-200 transition-all duration-300 font-medium rounded-md flex items-center space-x-2', sidebar ? 'hover:pl-1.5' : '')} to={'/races'}>
                <span className={classNames('flex p-1 bg-gray-800 rounded-md', sidebar ? 'mr-1' : '')}>
                  <img className={'transition-all duration-300', classNames(sidebar ? 'w-6' : 'w-8')} src={`/icons/RACES.svg`} alt="" />
                </span>
              </Link>
            ) : (
              racesData.map(race => (
                // <Link className={classNames('group relative text-gray-200 transition-all duration-300 font-medium rounded-md flex items-center space-x-2', sidebar ? 'hover:pl-1.5' : '')} to={href}></Link>
                <Link key={race.id} className={classNames('group relative text-gray-200 transition-all duration-300 font-medium rounded-md flex items-center space-x-2', sidebar ? 'hover:pl-1.5' : '')} to={`?modal=race&raceId=${race.id}`}>
                  <span className={classNames('flex p-1 bg-gray-800 rounded-md', sidebar ? 'mr-1' : '')}>
                    <img className={classNames(sidebar ? 'w-6' : 'w-8')} src={`/icons/RACES.svg`} alt="" />
                  </span>
                  <Transition className="flex-1 text-left truncate" as={'div'} show={sidebar}>
                    <Transition.Child
                      as={Fragment}
                      enter="transform delay-400 ease-out duration-300"
                      enterFrom="opacity-0 -translate-x-1 scale-95"
                      enterTo="opacity-100 translate-x-0 scale-100"
                      leave="transform ease-in duration-200"
                      leaveFrom="opacity-100 translate-x-0 scale-100"
                      leaveTo="opacity-0 -translate-x-1 scale-95"
                    >
                      <span className="absolute inset-y-0 whitespace-nowrap flex items-center">{race.title}</span>
                    </Transition.Child>
                  </Transition>
                </Link>
              ))
            )}
          </div>
          <div className="grid gap-3 py-6 overflow-hidden">
            {helpDesk.map(({ href, icon, label, onClick }, index) => (
              href ? (
                <Link key={index} className={classNames('group relative text-gray-200 transition-all duration-300 font-medium rounded-md flex items-center space-x-2', sidebar ? 'hover:pl-1.5' : '')} to={href}>
                  <span className={classNames('flex p-1 bg-gray-800 rounded-md', sidebar ? 'mr-1' : '')}>
                    <img className={classNames(sidebar ? 'w-6' : 'w-8')} src={`/icons/${icon}`} alt="" />
                  </span>
                  <Transition as={'div'} className="flex-1 text-left truncate" show={sidebar}>
                    <Transition.Child
                      as={Fragment}
                      enter="transform delay-400 ease-out duration-300"
                      enterFrom="opacity-0 -translate-x-1 scale-95"
                      enterTo="opacity-100 translate-x-0 scale-100"
                      leave="transform ease-in duration-200"
                      leaveFrom="opacity-100 translate-x-0 scale-100"
                      leaveTo="opacity-0 -translate-x-1 scale-95"
                    >
                      <span className="absolute inset-y-0 whitespace-nowrap flex items-center">{label}</span>
                    </Transition.Child>
                  </Transition>
                </Link>
              ) : (
                <button key={index} className={classNames('group relative text-gray-200 transition-all duration-300 font-medium flex items-center space-x-2', sidebar ? 'hover:pl-1.5' : '')} onClick={onClick}>
                  <span className={classNames('flex p-1 bg-gray-800 rounded-md', sidebar ? 'mr-1' : '')}>
                    <img className={classNames(sidebar ? 'w-6' : 'w-8')} src={`/icons/${icon}`} alt="" />
                  </span>
                  <Transition as={'div'} className="flex-1 text-left truncate" show={sidebar}>
                    <Transition.Child
                      as={Fragment}
                      enter="transform delay-400 ease-out duration-300"
                      enterFrom="opacity-0 -translate-x-1 scale-95"
                      enterTo="opacity-100 translate-x-0 scale-100"
                      leave="transform ease-in duration-200"
                      leaveFrom="opacity-100 translate-x-0 scale-100"
                      leaveTo="opacity-0 -translate-x-1 scale-95"
                    >
                      <span className="absolute inset-y-0 whitespace-nowrap flex items-center">{label}</span>
                    </Transition.Child>
                  </Transition>
                </button>
              )
            ))}
          </div>
        </div>
        <Transition as={'div'} className="text-left truncate mt-auto p-2" show={sidebar}>
          <Transition.Child
            as={'div'}
            enter="transform delay-500 ease-out duration-300"
            enterFrom="opacity-0 -translate-x-1 scale-95"
            enterTo="opacity-100 translate-x-0 scale-100"
            leave="transform ease-in duration-200"
            leaveFrom="opacity-100 translate-x-0 scale-100"
            leaveTo="opacity-0 -translate-x-1 scale-95"
          >
            <Button modifier="secondary" link to={modalRoutes.LINK_ACCOUNT} className="py-2.5 w-full">Request Account</Button>
          </Transition.Child>
        </Transition>
      </aside>

      {/* mobile */}
      <Transition show={sidebar}>
        <Transition.Child
          as={Fragment}
          {...SidebarTransition.Overlay}
        >
          <div onClick={toggleSidebar} className="lg:hidden fixed inset-0 bg-black bg-opacity-80 z-[300]"></div>
        </Transition.Child>
        <Transition.Child
          as={Fragment}
          {...SidebarTransition.Main}>
          <aside className='flex-col transition-[width] ease-out duration-300 h-screen overflow-auto inset-y-0 fixed z-[300] bg-gray-900 flex lg:hidden w-full sm:w-96'>
            <div className="flex justify-between p-4 border-b border-gray-800">
              <Link className="font-bold text-lg" to="/">
                <span>Duels.gg</span>
              </Link>
              <button className="text-gray-200 hover:text-gray-100" onClick={toggleSidebar}>
                <span><XIcon className="h-5 w-5" /></span>
              </button>
            </div>
            <div className='overflow-auto px-4'>
              <div className="grid gap-4 border-b border-gray-800 mt-4 pb-4 overflow-hidden">
                {links.map(({ href, icon, label, onClick }, index) => (
                  href ? (
                    <Link key={index} className="group relative text-gray-200 transition-all duration-300 font-medium rounded-md flex items-center space-x-2" to={href}>
                      <span className="flex p-1 bg-gray-800 rounded-md mr-1">
                        <img className={'transition-all duration-300 w-6'} src={`/icons/${icon}`} alt="" />
                      </span>
                      <Transition className="flex-1 text-left" as={'div'} show={sidebar}>
                        <Transition.Child
                          as={Fragment}
                          enter="transform delay-400 ease-out duration-300"
                          enterFrom="opacity-0 -translate-x-1 scale-95"
                          enterTo="opacity-100 translate-x-0 scale-100"
                          leave="transform ease-in duration-200"
                          leaveFrom="opacity-100 translate-x-0 scale-100"
                          leaveTo="opacity-0 -translate-x-1 scale-95"
                        >
                          <span className="absolute inset-y-0 whitespace-nowrap flex items-center">{label}</span>
                        </Transition.Child>
                      </Transition>
                    </Link>
                  ) : (
                    <button key={index} className="group relative text-gray-200 transition-all duration-300 font-medium flex items-center space-x-2" onClick={onClick}>
                      <span className='flex p-1 bg-gray-800 rounded-md mr-1'>
                        <img className='transition-all duration-300 w-6' src={`/icons/${icon}`} alt="" />
                      </span>
                      <Transition className="flex-1 text-left truncate" as={'div'} show={sidebar}>
                        <Transition.Child
                          as={Fragment}
                          enter="transform delay-400 ease-out duration-300"
                          enterFrom="opacity-0 -translate-x-1 scale-95"
                          enterTo="opacity-100 translate-x-0 scale-100"
                          leave="transform ease-in duration-200"
                          leaveFrom="opacity-100 translate-x-0 scale-100"
                          leaveTo="opacity-0 -translate-x-1 scale-95"
                        >
                          <span className="absolute inset-y-0 whitespace-nowrap flex items-center">{label}</span>
                        </Transition.Child>
                      </Transition>
                    </button>
                  )
                ))}
              </div>
              <div className="grid py-4 gap-1 border-b border-gray-800">
                {racesData.length == 0 ? (
                  sidebar ? <p className="py-4 text-gray-200">No promotions available</p> : <Link className="group relative text-gray-200 transition-all duration-300 font-medium rounded-md flex items-center space-x-2" to={'/races'}>
                    <span className='flex p-1 bg-gray-800 rounded-md mr-1'>
                      <img className="w-6" src={`/icons/RACES.svg`} alt="" />
                    </span>
                  </Link>
                ) : (
                  racesData.map(race => (
                    <Link key={race.id} className="group relative text-gray-200 transition-all duration-300 font-medium rounded-md flex items-center space-x-2" to={`?modal=race&raceId=${race.id}`}>
                      <span className="flex p-1 bg-gray-800 rounded-md mr-1">
                        <img className="w-6" src={`/icons/RACES.svg`} alt="" />
                      </span>
                      <Transition className="flex-1 text-left truncate" as={'div'} show={sidebar}>
                        <Transition.Child
                          as={Fragment}
                          enter="transform delay-400 ease-out duration-300"
                          enterFrom="opacity-0 -translate-x-1 scale-95"
                          enterTo="opacity-100 translate-x-0 scale-100"
                          leave="transform ease-in duration-200"
                          leaveFrom="opacity-100 translate-x-0 scale-100"
                          leaveTo="opacity-0 -translate-x-1 scale-95"
                        >
                          <span className="absolute inset-y-0 whitespace-nowrap flex items-center">{race.title}</span>
                        </Transition.Child>
                      </Transition>
                    </Link>
                  ))
                )}
              </div>
              <div className="grid gap-3 py-4 overflow-hidden">
                {helpDesk.map(({ href, icon, label, onClick }, index) => (
                  href ? (
                    <Link key={index} className="group relative text-gray-200 transition-all duration-300 font-medium rounded-md flex items-center space-x-2" to={href}>
                      <span className='flex p-1 bg-gray-800 rounded-md mr-1'>
                        <img className="w-6" src={`/icons/${icon}`} alt="" />
                      </span>
                      <Transition as={'div'} className="flex-1 text-left truncate" show={sidebar}>
                        <Transition.Child
                          as={Fragment}
                          enter="transform delay-400 ease-out duration-300"
                          enterFrom="opacity-0 -translate-x-1 scale-95"
                          enterTo="opacity-100 translate-x-0 scale-100"
                          leave="transform ease-in duration-200"
                          leaveFrom="opacity-100 translate-x-0 scale-100"
                          leaveTo="opacity-0 -translate-x-1 scale-95"
                        >
                          <span className="absolute inset-y-0 whitespace-nowrap flex items-center">{label}</span>
                        </Transition.Child>
                      </Transition>
                    </Link>
                  ) : (
                    <button key={index} className="group relative text-gray-200 transition-all duration-300 font-medium flex items-center space-x-2" onClick={onClick}>
                      <span className="flex p-1 bg-gray-800 rounded-md mr-1">
                        <img className="w-6" src={`/icons/${icon}`} alt="" />
                      </span>
                      <Transition as={'div'} className="flex-1 text-left truncate" show={sidebar}>
                        <Transition.Child
                          as={Fragment}
                          enter="transform delay-400 ease-out duration-300"
                          enterFrom="opacity-0 -translate-x-1 scale-95"
                          enterTo="opacity-100 translate-x-0 scale-100"
                          leave="transform ease-in duration-200"
                          leaveFrom="opacity-100 translate-x-0 scale-100"
                          leaveTo="opacity-0 -translate-x-1 scale-95"
                        >
                          <span className="absolute inset-y-0 whitespace-nowrap flex items-center">{label}</span>
                        </Transition.Child>
                      </Transition>
                    </button>
                  )
                ))}
              </div>
            </div>
            <Button modifier="secondary" link to={modalRoutes.LINK_ACCOUNT} className="py-2.5 w-full mt-auto">Request Account</Button>
          </aside>
        </Transition.Child>
      </Transition>
    </>
  )
}